module.exports = __webpack_public_path__ + "static/media/tauchsieder_antwort.d45ba32c.jpg";